import React from 'react';
import { ShieldCheck } from 'lucide-react';
import LegalDoc, { LegalDocData } from '../components/LegalDoc';
import legal from '../content/legal.json';

export default function Safety() {
  return (
    <LegalDoc
      doc={legal.safety as LegalDocData}
      icon={<ShieldCheck className="w-6 h-6 text-emerald-500" />}
      tagline="Last updated: September 2026"
    />
  );
}
